import { useFormik } from "formik";
import axiosInstance from "../axiosInterceptor";
import Breadcrumb from "../helper/Breadcrumb";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Upload from "../Components/upload";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { SwitchToggle } from "../helper/ImageFormat";
import { TestimonialSchema } from "../Schema/Schema";
import CodeEditor from "../Components/CodeEditor";

const AddTestimonial = () => {
 const location = useLocation();
 const navigate = useNavigate();
 const editData = location.state;
 const editingId = editData?.id;

 const [loading, setLoading] = useState(false);

 const initialValues = {
  review_date: "",
  position: editData?.position || editData?.nextPosition,
  customer_name: "",
  review: "",
  rating: "",
  image: "",
  isActive: true,
 };

 const {
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
  setFieldValue,
 } = useFormik({
  initialValues,
  validationSchema: TestimonialSchema,
  onSubmit: async (values) => {
   setLoading(true);
   try {
    const response = editingId
     ? await axiosInstance.put(`/testimonial/${editingId}`, values)
     : await axiosInstance.post("/testimonial", values);

    toast.success(response?.data?.message || "Testimonial saved");
    navigate("/testimonials");
   } catch (err) {
    toast.error(err?.response?.data?.message || "Something went wrong");
   } finally {
    setLoading(false);
   }
  },
 });

 useEffect(() => {
  if (editingId && editData) {
    setFieldValue(
      "review_date",
      editData?.review_date
        ? new Date(editData.review_date).toISOString().split("T")[0]
        : ""
    );

   setFieldValue("customer_name", editData?.customer_name || "");
   setFieldValue("review", editData?.review || "");
   setFieldValue("rating", editData?.rating || "");
   setFieldValue("image", editData?.image || "");
   setFieldValue("isActive", editData?.isActive ?? true);
  }
 }, [editingId, editData, setFieldValue]);

 const breadcrumbdata = [
  { label: "Home", path: "/" },
  {
   label: editingId ? "Update Testimonial" : "Add Testimonial",
   path: "*",
  },
 ];

 return (
  <div className="content-wrapper">
   <div className="page-header mt-4">
    <h3 className="page-title">{editingId ? "Update" : "Add"} Testimonial</h3>
    <Breadcrumb items={breadcrumbdata} />
   </div>

   <div className="row grid-margin stretch-card">
    <div className="col-md-12">
     <div className="card">
      <div className="card-body">
       <form onSubmit={handleSubmit}>
        <div className="row g-3">
         <div className="col-lg-6 co-md-12">
          <label className="col-form-label">Sort Order</label>
          <input
           type="number"
           name="position"
           id="position"
           placeholder="Sort Order"
           value={values.position ?? ""}
           onChange={handleChange}
           className="form-control form-control-lg border border-dark"
           min={1}
          />
         </div>
         <div className="col-lg-6 co-md-12">
          <label className="col-form-label">Date</label>
          <input
           type="date"
           name="review_date"
           value={values.review_date}
           onChange={handleChange}
           onBlur={handleBlur}
           className="form-control border border-dark"
          />
          {touched.review_date && errors.review_date && (
           <small className="text-danger">{errors.review_date}</small>
          )}
         </div>
         <div className="col-lg-6 co-md-12">
          <label className="col-form-label">Name</label>
          <input
           type="text"
           name="customer_name"
           placeholder="Customer name"
           value={values.customer_name}
           onChange={handleChange}
           onBlur={handleBlur}
           className="form-control border border-dark"
          />
          {touched.customer_name && errors.customer_name && (
           <small className="text-danger">{errors.customer_name}</small>
          )}
         </div>

         <div className="col-lg-6 co-md-12">
          <label className="col-form-label">Rating</label>
          <input
           type="number"
           name="rating"
           placeholder="1 - 5"
           value={values.rating}
           onChange={handleChange}
           onBlur={handleBlur}
           className="form-control border border-dark"
          />
          {touched.rating && errors.rating && (
           <small className="text-danger">{errors.rating}</small>
          )}
         </div>

         <div className="col-md-12">
          <label className="col-form-label">Review</label>
          <CodeEditor
                            placeholder="Enter Review..."
                            value={values.review}
                            onChange={(val) => setFieldValue("review", val)}
                          />
          {touched.review && errors.review && (
           <small className="text-danger">{errors.review}</small>
          )}
         </div>

         <div className="col-md-12 mt-4">
          <label className="form-label fw-bold">Upload Image</label>
          <Upload
           label="testimonial-image"
           initialImage={values.image}
           onChange={(img) => setFieldValue("image", img)}
           apiUrl="uploads?label=testimonial"
          />
         </div>
         <div className="col-md-12 mt-4">
          <SwitchToggle
           checked={values.isActive}
           onChange={(val) => setFieldValue("isActive", val)}
           activeLabel="Active"
           inactiveLabel="Inactive"
          />
         </div>

         {/* Buttons */}
         <div
          className="col-12 mt-4 d-flex justify-content-center"
          style={{ gap: "15px" }}
         >
          <button type="submit" className="btn btn-primary" disabled={loading}>
           {loading ? "Saving..." : editingId ? "Update" : "Add"}
          </button>

          <Link to="/testimonials">
           <button type="button" className="btn btn-danger">
            Cancel
           </button>
          </Link>
         </div>
        </div>
       </form>
      </div>
     </div>
    </div>
   </div>
  </div>
 );
};

export default AddTestimonial;
